
/**
 * This function is called whenever web chat receives a custom response and we need construct the content for web chat
 * to display.
 * 
 * 
 * 
 */


function carouselCustomResponseHandler(event, instance) {
  const { element, message } = event.data;
  const ms = event.data.fullMessage.context.skills['actions skill'].skill_variables.table_results
  console.log("flag1:",event.data);
  event.data.fullWidth = true;
  element.style.maxWidth = "320px";
  element.style.margin = "0 auto";
  element.style.padding = "0";

  // This will define the main HTML content we want to display in this custom response. We will add the individual
  // carousel items below.
  element.innerHTML = `
    <div>
    <br/>
    <div class="Carousel">
      <div class="swiper">
        <div class="swiper-wrapper"></div>
      </div>
      <div class="Carousel__Navigation" >
        <button type="button" class="Carousel__NavigationButton Carousel__NavigationPrevious cds--btn cds--btn--ghost">
          <svg fill="currentColor" width="16" height="16" viewBox="0 0 32 32" aria-hidden="true"><path d="M20 24L10 16 20 8z"></path></svg>
        </button>
        <div class="Carousel__BulletContainer"></div>
        <button type="button" class="Carousel__NavigationButton Carousel__NavigationNext cds--btn cds--btn--ghost">
          <svg fill="currentColor" width="16" height="16" viewBox="0 0 32 32" aria-hidden="true"><path d="M12 8L22 16 12 24z"></path></svg>
        </button>
      </div>
    </div>
    </div>`;

  // const thumbsUpButton = element.querySelector('.Carousel__ThumbUpButton');
  // const thumbsDownButton = element.querySelector('.Carousel__ThumbDownButton');

  // thumbsUpButton.addEventListener('click', () => {
  //   thumbsUpButton.classList.add('active');
  //   thumbsDownButton.classList.remove('active');
  // });

  // thumbsDownButton.addEventListener('click', () => {
  //   thumbsDownButton.classList.add('active');
  //   thumbsUpButton.classList.remove('active');
  // });
  // Once we have the main HTML, create each of the individual slides that will appear in the carousel.
  const slidesContainer = element.querySelector('.swiper-wrapper');
  createSlides(slidesContainer, ms, instance);

  // Initialize the Swiper library which is what we are using to control the carousel. We are using a custom pagination
  // element to control pagination and navigation.
  // eslint-disable-next-line no-new
  new Swiper(element.querySelector('.swiper'), {
    modules: [Navigation, Pagination, A11y],
    keyboard: {
      enabled: true,
    },
    pagination: {
      el: element.querySelector('.Carousel__BulletContainer'),
      clickable: true,
      bulletClass: 'Carousel__Bullet',
      bulletActiveClass: 'Carousel__Bullet--selected',
      renderBullet,
    },
    navigation: {
      prevEl: element.querySelector('.Carousel__NavigationPrevious'),
      nextEl: element.querySelector('.Carousel__NavigationNext'),
    },
    slidesPerView: 'auto',
    spaceBetween: 10,
    centeredSlides: false,
    rewind: true,
  });
}

/**
 * This function will create the individual slides to display in the carousel. This will use the "carousel_data" value
 * that is provided as part of the message from the assistant. Each slide will have two buttons. The first button
 * will be a link to another web page. The second button will send a message to the assistant to get more data
 * within web chat for the desired card.
 */
async function createSlides(slidesContainer, message, webChatInstance) {
  const carouselData = message;

  // Clear old slides (optional)
  slidesContainer.innerHTML = "";

  // Loop through each product card
  carouselData.forEach((cardData) => {
    const title = cardData.product_name;
    const url = cardData.link;
    const description = "Price : Rs. " + cardData.price;
    const imgLink =
      cardData.product_images_1_links ||
      "https://img.freepik.com/free-photo/vivid-blurred-colorful-wallpaper-background_58702-2430.jpg?size=626&ext=jpg";

    const cardElement = document.createElement("div");
    cardElement.classList.add("swiper-slide");

    cardElement.innerHTML = `
      <div class="cds--tile Carousel__Card">
        <img class="Carousel__CardImage" src="${imgLink}" />
        <div class="Carousel__CardContent">
          <div class="Carousel__CardText">
            <div class="Carousel__CardTitle">${title}</div>
            <div class="Carousel__Nutrition" style="display:none; margin-top:10px; background:#f9f9f9; border-radius:8px; padding:10px;"></div>
          </div>
          <div class="Carousel__CardButtons">
            <button type="button" class="Carousel__CardButton Carousel__CardButtonIngredient cds--btn cds--btn--primary">
              Ingredient List
            </button>
            <button type="button" class="Carousel__CardButton Carousel__CardButtonTellMe cds--btn cds--btn--primary">
              Tell me more about this
            </button>
          </div>
        </div>
      </div>
    `;

    // "Tell me more about this" -> sends message to assistant
    const tellMeButton = cardElement.querySelector(".Carousel__CardButtonTellMe");
    tellMeButton.addEventListener("click", () => {
      webChatInstance.send({ input: { text: `Tell me about ${title}` } }, { silent: false });
    });

    // "Ingredient List" -> fetch from backend API
    const ingredientButton = cardElement.querySelector(".Carousel__CardButtonIngredient");
    const nutritionDiv = cardElement.querySelector(".Carousel__Nutrition");

    ingredientButton.addEventListener("click", async () => {
      ingredientButton.textContent = "Loading...";
      try {
        const response = await fetch(`http://0.0.0.0:3001/api/nutrition?item=${encodeURIComponent(title)}`);
        const json = await response.json();

        if (json.success && json.data) {
          const nutrition = json.data;
          let html = `<strong>Nutritional Info:</strong><br/>`;
          html += `<ul style="list-style:none; padding-left:0;">`;
          for (const [key, value] of Object.entries(nutrition)) {
            html += `<li><b>${key}</b>: ${value}</li>`;
          }
          html += `</ul>`;

          nutritionDiv.innerHTML = html;
          nutritionDiv.style.display = "block";

          //  Hide the ingredient button once data is shown
          ingredientButton.style.display = "none";
        } else {
          nutritionDiv.innerHTML = `<span style="color:red;">No data found for ${title}</span>`;
          nutritionDiv.style.display = "block";
        }

      } catch (err) {
        nutritionDiv.innerHTML = `<span style="color:red;">Error fetching data</span>`;
        nutritionDiv.style.display = "block";
        console.error("Error fetching nutrition:", err);
      } finally {
        ingredientButton.textContent = "Ingredient List";
      }
    });

    slidesContainer.appendChild(cardElement);
  });
}


/**
 * Renders a custom bullet to be displayed in the pagination element.
 */
function renderBullet(_, className) {
  return `<button class="${className} cds--btn cds--btn--ghost" type="button"></button>`;
}

export { carouselCustomResponseHandler };